<div>
    <mat-form-field *ngIf="!hideSuche" class="no-padding-margin-mat-form-field" style="width: 100%">
        <mat-label>Suchen</mat-label>
        <mat-icon matPrefix style="padding-right: 6px">search</mat-icon>
        <input [formControl]="searchCtrl" matInput />
    </mat-form-field>

    <mat-divider style="margin-bottom: 12px"></mat-divider>

    <div *ngIf="isMobileSelectionActive() && selectedCount > 0" class="mobile-selection-popup">
        <button
            (click)="discardSelection()"
            [disabled]="selectedCount === 0"
            aria-label="Selektion verwerfen"
            class="mobile-selection-popup-close"
            color="primary"
            mat-icon-button
        >
            <mat-icon>close</mat-icon>
        </button>

        <button
            [disabled]="selectedCount === 0"
            [matMenuTriggerFor]="selectedAnimalsMenu"
            class="mobile-selection-actions-btn"
            color="primary"
            mat-flat-button
        >
            <mat-icon>edit</mat-icon>
            Aktionen ({{ selectedCount }})
        </button>
    </div>

    <div class="one-row tier-toolbar-row">
        <div *ngIf="isMobileSelectionActive() && !hideInlineSelectAllButton" class="mobile-selection-inline-actions">
            <button
                (click)="toggleSelectAllVisibleTiere()"
                [matTooltip]="'Alle auswählen'"
                aria-label="Alle auswählen"
                color="accent"
                mat-icon-button
            >
                <mat-icon>{{ areAllVisibleTiereSelected() ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            </button>

        </div>
        <span class="spacer tier-toolbar-spacer"></span>

        <div class="tier-toolbar-secondary-actions">
            <button (click)="reloadEvent()" *ngIf="!hideReloadButton" color="accent" mat-icon-button>
                <mat-icon>refresh</mat-icon>
            </button>

            <button (click)="openHilfe()" *ngIf="!hideHilfeButton" color="accent" mat-icon-button>
                <mat-icon>help</mat-icon>
            </button>

            <kiene-gruppe-tier-sortierung-button
                (selectedFilter)="sortiereTiere($event)"
                *ngIf="!hideSortierung"
            ></kiene-gruppe-tier-sortierung-button>

            <kiene-gruppe-tier-filter-button
                #filterButton
                (filterSelected)="setFilterSettings($event)"
                *ngIf="!hideFilter"
                [gruppe]="gruppe"
                [tierFilterSettings]="filterSettings"
            >
            </kiene-gruppe-tier-filter-button>

            <ng-content select="[additional-actions]"></ng-content>
        </div>

    </div>

    <mat-menu #selectedAnimalsMenu="matMenu">
        <button
            (click)="ausstallenSelected()"
            *kienePermission="[9322]"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0"
            mat-menu-item
        >
            <mat-icon>logout</mat-icon>
            <span>(selektierte) Tiere ausstallen</span>
        </button>

        <button (click)="markSelectedAsScanned()" *kienePermission="[9122]" [disabled]="gruppe?.historie > 0" mat-menu-item>
            <mat-icon>label</mat-icon>
            <span>Ohrmarken als gescannt markieren</span>
        </button>

        <button (click)="addCommentToSelected()" *kienePermission="[9129]" [disabled]="gruppe?.historie > 0" mat-menu-item>
            <mat-icon>add_comment</mat-icon>
            <span>Bemerkung hinzufügen</span>
        </button>

        <button (click)="changeGroupForSelected()" *kienePermission="[9122]" [disabled]="gruppe?.historie > 0" mat-menu-item>
            <mat-icon>sync_alt</mat-icon>
            <span>Gruppe ändern</span>
        </button>

        <button
            (click)="changeAbteilForSelected()"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0"
            mat-menu-item
        >
            <mat-icon>sync_alt</mat-icon>
            <span>Abteil ändern</span>
        </button>

        <button
            (click)="changeHaendlerForSelected()"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0"
            mat-menu-item
        >
            <mat-icon>sync_alt</mat-icon>
            <span>Händler ändern</span>
        </button>

        <button
            (click)="openKontaktSetzenDialog()"
            *kienePermission="[11014]"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0"
            mat-menu-item
        >
            <mat-icon>contacts</mat-icon>
            <span>Kontakt zuordnen</span>
        </button>

        <button
            (click)="openHerkunftSetzenDialog()"
            *kienePermission="[11014]"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0"
            mat-menu-item
        >
            <mat-icon>location_on</mat-icon>
            <span>Herkunftsbetrieb setzen</span>
        </button>

        <button
            (click)="openReklamationenSetzenDialog()"
            *kienePermission="[9129]"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0"
            mat-menu-item
        >
            <mat-icon>report_problem</mat-icon>
            <span>Reklamationen setzen</span>
        </button>

        <button
            (click)="changeEinstalldatumForSelected()"
            *kienePermission="[9128]"
            [disabled]="gruppe?.historie > 0 || isEinstalldatumHitGesperrt()"
            mat-menu-item
        >
            <mat-icon>today</mat-icon>
            <span>Einstalldatum ändern</span>
        </button>

        <button
            (click)="changeAbgangsdatumForSelected()"
            *kienePermission="[9129]"
            [disabled]="gruppe?.historie > 0 || isAbgangsdatumHitGesperrt()"
            mat-menu-item
        >
            <mat-icon>event</mat-icon>
            <span>Abgangsdatum ändern</span>
        </button>

        <button disabled mat-menu-item>
            <mat-icon>biotech</mat-icon>
            <span>Zertifizierungsdatei an SGS senden</span>
        </button>

        <button
            (click)="openPreiseFestlegenDialog()"
            *kienePermission="[11015]"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0"
            mat-menu-item
        >
            <mat-icon>euro</mat-icon>
            <span>Preise festlegen</span>
        </button>

        <button
            (click)="openGewichteFestlegenDialog()"
            [disabled]="gruppe?.historie > 0 || selectedCount === 0 || !canChangeGewichte()"
            mat-menu-item
        >
            <mat-icon>fitness_center</mat-icon>
            <span>Gewichte festlegen</span>
        </button>

        <button (click)="setAussendienstForSelected()" *kienePermission="[9178]" [disabled]="gruppe?.historie > 0" mat-menu-item>
            <mat-icon>person</mat-icon>
            <span>Außendienst setzen</span>
        </button>
    </mat-menu>

    <div *ngIf="!gruppeTiere || gruppeTiere?.length === 0">
        <div class="hinweis-text" style="padding: 24px 0 64px 0; text-align: center">
            <span *ngIf="isLoading">Lade Tiere...</span>

            <div *ngIf="!isLoading && gruppeTiere.length === 0">
                <span *ngIf="selectedTierFilter === tierFilter.ALLE_TIERE && !searchCtrl.value && selectedAbteil">
                    In der Gruppe sind keine Tiere vorhanden.
                </span>

                <span *ngIf="searchCtrl.value || validFilterSettings(filterSettings)">
                    Zu den angewandten Suchkriterien sind keine Tiere vorhanden.
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="gruppeTiere && gruppeTiere?.length > 0" class="tiere-list-container">
        <ng-container *ngFor="let tier of gruppeTiere">
            <div
                [class.mobile-selection-item--selected]="isTierSelected(tier)"
                (click)="onTierClick(tier, $event)"
                (contextmenu)="onTierContextMenu($event)"
                (mousedown)="onTierMouseDown(tier)"
                (mouseleave)="onTierMouseLeave()"
                (mouseup)="onTierMouseUp()"
                (touchcancel)="onTierTouchCancel()"
                (touchend)="onTierTouchEnd()"
                (touchmove)="onTierTouchMove()"
                (touchstart)="onTierTouchStart(tier)"
                style="margin-bottom: 12px"
            >
                <kiene-gruppe-tier-card
                    (reload)="reloadEvent()"
                    [disableCardClickDetails]="isSelectionMode && isMobileSelectionActive()"
                    [gewichteFestlegenDisabled]="gruppe?.historie > 0"
                    [hideBearbeitenButton]="watchMode"
                    [hideGruppe]="true"
                    [hideLoeschenButton]="watchMode"
                    [isSelected]="isTierSelected(tier)"
                    [showGewichteFestlegen]="canChangeGewichte()"
                    [suppressContextMenu]="isMobileSelectionActive()"
                    [tier]="tier"
                >
                </kiene-gruppe-tier-card>
            </div>
        </ng-container>
    </div>
</div>
